
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';

interface IProps {
  width?: string;
}

const GroupHeader: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <EDTypography
      width={props.width}
      bold
      variant="overline"
      color="textSecondary"
    >
      {props.children}
    </EDTypography>
  );
};

export default GroupHeader;
